const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/settings/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
import { parseAdminSettingsSearch } from "./-parseAdminSettingsSearch";
export const Route = createFileRoute("/_app/admin/settings/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Settings")
    }]
  }),
  validateSearch: parseAdminSettingsSearch,
  loaderDeps: () => ({}),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});